<template>
  <div>
    <div class="banner">
      <h4>{{ resource.id ? 'Editar Usuário' : 'Novo Usuário' }}</h4>
    </div>

    <AlertError class="mb-5" v-model="displayError" :resource="displayError" />

    <v-form @submit.prevent="create" ref="form">
      <v-row dense>
          <v-col class="d-flex" cols="12" sm="12">
            <v-text-field 
              class="rounded-lg"  
              placeholder="Nome completo" 
              color="#41916b"
              outlined v-model="resource.name"
              :rules="nameRules" 
              dense>
                <template v-slot:label>
                  Nome<span style="color: red">*</span>
                </template>
            </v-text-field>
          </v-col>

          <v-col class="d-flex" cols="12" sm="7">
            <v-text-field 
              class="rounded-lg"  
              placeholder="CPF" 
              color="#41916b"
              outlined 
              v-model="resource.cpf" 
              maxlength="14"
              :rules="cpfRules"  
              dense>
                <template v-slot:label>
                  CPF <span style="color: red">*</span>
                </template>
            </v-text-field>
          </v-col>
          
          <v-col class="d-flex" cols="12" sm="5">
            <v-select 
              :rules="sexRules" 
              :items="sex" 
              v-model="resource.sex_id" 
              item-text="name" 
              item-value="id" 
              color="#41916b"
              dense outlined
              class="rounded-lg">
              <template v-slot:label>
                Sexo <span style="color: red">*</span>
              </template>
            </v-select>
          </v-col>

          <v-col class="d-flex" cols="12" sm="7">
            <v-text-field 
              class="rounded-lg"  
              placeholder="E-mail" 
              color="#41916b"
              outlined v-model="resource.email"
              :rules="emailRules" 
              dense>
                <template v-slot:label>
                  E-mail <span style="color: red">*</span>
                </template>
            </v-text-field>
          </v-col>
          
          <v-col class="d-flex" cols="12" sm="5">
            <v-text-field 
              class="rounded-lg"   
              color="#41916b"
              outlined 
              v-model="resource.telephone"
              :rules="telephoneRules" 
              v-mask="'(##)#####-####'"
              maxlength="15" 
              dense>
                <template v-slot:label>
                  Telefone <span style="color: red">*</span>
                </template>
            </v-text-field>
          </v-col>
          
          <v-col class="d-flex" cols="12" sm="12" v-if="!isEditMode">
            <v-autocomplete 
              :rules="perfilRules" 
              :items="unities" 
              v-model="resource.unity_id" 
              item-text="hospital" 
              item-value="id" 
              dense
              outlined 
              color="#41916b"
              class="rounded-lg"
              label="Unidade">
                <template v-slot:label>
                  Unidade <span style="color: red">*</span>
                </template>
            </v-autocomplete>
          </v-col> 

          <!-- <v-text-field 
          class="rounded-lg" 
          label="Matrícula" 
          color="#41916b"
          placeholder="Matrícula" 
          outlined 
          v-model="resource.registration" 
          maxlength="11" 
          dense></v-text-field> -->
 
          <v-col class="d-flex" cols="12" sm="12" v-if="!isEditMode">
            <v-autocomplete 
              :rules="perfilRules" 
              :items="perfil" 
              v-model="resource.profile_id" 
              item-text="name" 
              item-value="id" 
              dense
              outlined 
              color="#41916b"
              class="rounded-lg">
                <template v-slot:label>
                  Perfil <span style="color: red">*</span>
                </template>
            </v-autocomplete>
          </v-col>
          
      </v-row>
      

      <v-card-actions class="cardFooter">
          <v-spacer></v-spacer>
            <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
              <span>{{$t('buttons.cancel')}}</span>
            </v-btn>

            <v-btn class="rounded-lg" color="blue" text elevation="0" @click="$refs.form.reset()">
              <span>{{$t('buttons.clean_up')}}</span>
            </v-btn>

            <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
              <span class="textBtn">{{ resource.id ? 'Salvar alterações' : 'Salvar Usuário' }}</span>
              <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
            </v-btn>
      </v-card-actions>
    </v-form> 
  </div>
</template>
  
<script>
import { saveUser, getProfilesList, getSex, getUserUnities } from "@/service/basic-registrations/UserService";
import AlertError from "../alerts/Error-component.vue";
import Formatters from "@/utils/Formatters";
import { mapActions } from "vuex";
export default {
  data() {
    return {
        dialog: false,
        search: "",
        headers: [
          { text: "CPF", value: "cpf" },
          { text: "Nome", value: "name", },
          { text: "Tipo de Perfil", value: "profile" },
          { text: "Ações", value: "actions", align:"center", sortable: false },
        ],
        nameRules: [(v) => !!v || "O campo é obrigatório"],
        emailRules: [
          (v) => !!v || "O campo é obrigatório",
          (v) => /.+@.+/.test(v) || "O e-mail não é válido.",
        ],
        cpfRules: [(v) => !!v || "O campo é obrigatório"],
        sexRules: [(v) => !!v || "Campo obrigatório."],
        telephoneRules: [(v) => !!v || "Campo obrigatório."],
        registrationRules: [(v) => !!v || "Campo obrigatório."],
        perfilRules: [(v) => !!v || "Campo obrigatório."],

        displayError: {
          display: false,
          message: [],
        },

        page: 1,
        totalUsers: 0,
        numberOfPages: 0,
        passengers: [],
        loading: false,
        options: {},
        sortBy: "name",
        isTecnHemoba: false,
        usuarios: [],
        message: "",
        snackbar: false,
        loadingBTN: false,
        exibirMensagem: false,
        messageError: "",
        unity_id: localStorage.getItem('item-unidade'), //recebe o valor do id da unidade 
        sex: "",
        perfil: "",
        name: "",
        cpf: "",
        sex_id: "",
        email: "",
        telephone: "",
        registration: "",
        profile_id: "",
        unities: [],
      };
  },

  props: {
      resource: {
        type: Object,
      },

      openDialog: {
        type: Boolean,
      }
    },

  components: {
    AlertError,
  },

  computed: {
    isEditMode() {
      return Boolean(this.resource && this.resource.id);
    },
  },

  watch: {
    sortBy: {
      handler() {}
    },
    
    options: {
      handler() {
        this.loadGridData();
      },
    },

    openDialog: {
      handler() {
        if(this.openDialog == true && this.resource.id){
          this.resource.unity_id = parseInt(this.resource.unity_id);
          this.resource.sex_id = parseInt(this.resource.sex_id);
          this.resource.profile_id = parseInt(this.resource.profile_id);
          this.loadGridData();
        } 
      },
      immediate: true,
    }
  },

  methods: {

    ...mapActions(["changeSnackBarData"]), 
    loadGridData() {
      this.dialog = true;
      getProfilesList().then((result) => { this.perfil = result; });
      getSex().then((result) => { this.sex = result; });
      getUserUnities().then((result) => { this.unities = result; });
    },
  
    create() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.resource.cpf = Formatters.removeNonNumeric(this.resource.cpf);

        let vinculos = [{
          unity_id: this.resource.unity_id,
          profile_id: this.resource.profile_id
        }]

        let dados = this.resource
            dados.vinculos = vinculos

            saveUser(this.resource.id || null, dados).then((response) => {
              this.loading = false;
              this.changeSnackBarData({
                status: true,
                type: "success",
                titleMessage: response.data.message,
                bodyMessage: "",
                cardColor: "#41916b",
                titleIcon: "mdi-checkbox-marked-circle",
              });

            setTimeout(() => { 
              this.closeDialog(); 
              this.closeSnackBar();
            }, 3000); 
          }).catch((err) => {
            this.loading = false; 

            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => { 
              this.closeSnackBar(); 
            }, 5000);
          });   
      }
    },

    closeDialog() {
      this.$emit("closeDialog");
      this.resource = {};
      this.$refs.form.reset();  
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },

  mounted() {
    this.loadGridData();
  },
};
</script>
  
<style scoped>
.header-table {
  display: flex;
  margin-bottom: 20px;
}

.space {
  width: 15px;
}
.spacediferent {
  width: 7px;
}

.unity{
  font-size: 12px;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.0125em;
    font-family: 'Roboto';
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
  